import { withIcon } from '@/camo/icons/with-icon'
import { Alert as BaseAlert } from 'baseui/icon'

const Alert = withIcon(BaseAlert, { title: 'Alert' })

export { Alert }
